import * as React from "react";
import { useCallback } from "react";
import * as Immutable from "immutable";
import ParameterDeclarationForm from "enterprise/parameters/components/ParameterDeclarationForm";
import newParameterState from "enterprise/parameters/logic/newParameterState";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useParametersMap from "views/hooks/useParametersMap";
import { declareParameters } from "views/logic/slices/searchExecutionSlice";
const CreateParameterDialog = ({ onClose }) => {
  const dispatch = useViewsDispatch();
  const existingParameters = useParametersMap();
  const onSave = useCallback(
    (newParameters2) => dispatch(declareParameters(newParameters2)).then(onClose),
    [dispatch, onClose]
  );
  const newParameters = Immutable.Map({
    newParameter: newParameterState("newParameter")
  });
  return /* @__PURE__ */ React.createElement(
    ParameterDeclarationForm,
    {
      allowEditingName: true,
      existingParameters,
      parameters: newParameters,
      "data-testid": "parameter-declaration-form",
      onSave,
      onClose
    }
  );
};
export default CreateParameterDialog;
